/**
 * Couleurs qu'une recommandation prend quand elle n'en porte pas les siennes : rouge jusqu'au
 * sixième cran, orange sur les deux suivants, vert au-delà — les trois classes que l'analyse
 * distingue. Ce sont elles que le mode gradué inscrit dans le brouillon.
 */
export const DEFAULT_NPS_COLORS = {
    negative: '#f5222d',
    neutral: '#faad14',
    positive: '#52c41a',
};

/**
 * Couleurs d'un NPS, une par classe de répondant. L'échelle, elle, est imposée : de 0 à 10, et les
 * seuils qui séparent détracteurs, passifs et promoteurs ne se règlent pas.
 */
export interface NpsColorStyle {
    [field: string]: unknown;

    /** Détracteurs. */
    negative?: string;

    /** Passifs. */
    neutral?: string;

    /** Promoteurs. */
    positive?: string;

    /**
     * Vrai quand les trois couleurs ci-dessus priment sur celles du thème — l'échelle est alors
     * graduée. Faux, elle est rendue à la couleur des réponses, la même du zéro au dix.
     */
    customColor?: boolean;
}
